import { contract_tab, info_tab, versioning_tab } from '../../../../../../views/contract/agreement';

export default {
  title: 'Vertragsdetails',
  tabs: {
    [info_tab]: 'Info',
    [contract_tab]: 'Vertrag',
    [versioning_tab]: 'Versionierung',
  },
  sections: {
    price_info: 'Preisinfo',
    contact: 'Laufender Vertrag',
    signature_history: 'Unterschriftsverlauf',
  },
  labels: {
    not_signed: 'Der Vertrag wurde noch nicht unterzeichnet',
  },
  modals: {
    preview_contract: {
      title: 'Vorschau Vertrag',
    },
    switch_to_annual: {
      title: 'Auf Jahresvertrag umstellen',
    },
  },
  buttons: {
    save: 'Speichern',
    preview_and_sign: 'Vorschau und Unterschrift',
    download: 'Herunterladen',
    switch_to_annual: 'Auf Jahresvertrag umstellen',
  },
  toasts: {
    failed_to_load_data: 'Daten konnten nicht geladen werden',
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    changes_got_saved: 'Änderungen wurden gespeichert',
  },
};
